import styled from 'styled-components';

export const CardGuestContainer = styled.div`
  display: flex;
  margin-top: 12px;

  > img {
    border: 1.5px solid var(--white-color);
    margin-right: -10px;
  }
`;

export const WroteCountBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 6px 4px 6px;
  border-radius: 30px;
  background-color: var(--white-color);
  color: var(--black-color);
  font-size: 12px;
  font-weight: 400;
`;
